{
  "version": 1,
  "features": [
    {
      "name": "asset_module",
      "description": "Asset module feature",
      "environments": {
        "development": {
          "enabled": true,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        },
        "staging": {
          "enabled": true,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        },
        "production": {
          "enabled": true,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        }
      }
    },
    {
      "name": "ge_connector",
      "description": "Feature to enable/disable a connector with GE Aerospace to share data with them.",
      "environments": {
        "development": {
          "enabled": true,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        },
        "staging": {
          "enabled": true,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        },
        "production": {
          "enabled": false,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        }
      }
    },
    {
      "name": "inspection_root_only_assets",
      "description": "When enabled, shows the 'Display roots only' checkbox in the inspection asset dropdown so users can switch between root-only and all assets. When disabled, the dropdown is locked to root-only and the all-assets API call is skipped.",
      "environments": {
        "development": {
          "enabled": true,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        },
        "staging": {
          "enabled": true,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        },
        "production": {
          "enabled": true,
          "strategies": [
            {
              "name": "default",
              "parameters": {}
            }
          ]
        }
      }
    }
  ]
}
